const formMeta = {
    formAction: '',
    iscompleted: false,
}

export const prefeasibilityDefaultValues = {
    project_status_and_readiness: {
        current_development_phase: '',
        readiness_for_procurement: '',
        regulatory_approvals_status: [],
        other_regulatory_approval: '',
        stakeholder_engagement_status: '',
        procurement_readiness: '',
        regulatory_readiness: '',
        stakeholder_readiness: '',
        ...formMeta,
    },

    governance_and_compliance: {
        policy_alignment: [],
        policy_alignment_rationale: '',
        delivery_incentives_penalties: '',
        legal_compliance_status: '',
        implementation_model: '',
        ...formMeta,
    },

    procurement_readiness: {
        supplier_market_maturity: '',
        risk_sharing_mechanism: [],
        bfi_alternative_financing_model_id: 0,
        documents: [],
        budget_statement: '',
        procurement_procedure: '',
        procurement_plan: '',
        ...formMeta,
    },

    implementation_readiness: {
        imple_timeline_planning_start: null,
        imple_timeline_planning_end: null,

        imple_timeline_procurement_start: null,
        imple_timeline_procurement_end: null,

        imple_timeline_delivery_start: null,
        imple_timeline_delivery_end: null,

        imple_timeline_operational_start: null,
        imple_timeline_operational_end: null,

        key_constraints: [],
        delivery_model_confidence_score: 0,
        ...formMeta,
    },

    stakeholder_and_communication_readiness: {
        investor_engagement_status: '',
        community_participation_status: '',
        government_coordination_level: '',
        ...formMeta,
    },

    risk_and_quality_gate: {
        ...formMeta,
    },
    governance_policy_enabling_environment: {
        government_policies_governance_role: '',
        governance_structure: '',
        internal_controls_accountability: '',
        partner_agencies: [],
        agreements_dispute_resolution: '',
        signed_agreements_upload_placeholder: [],
        incentives_penalties_framework: '',
        national_policy_alignment: '',
        regulatory_compliance_frameworks: [],
        policy_alignment_summary_bfi_consistency: '',
        ...formMeta,
    },
    economic_and_commercial_viability: {
        value_for_money_assessment: '',
        benefit_analysis: '',
        risk_evaluation_and_contingent_liability: '',
        economic_multipliers_and_macroeconomic_benefits: '',
        economies_of_scale: '',
        ...formMeta,
    },
    documents: {
        documents: [],
        ...formMeta,
    },
    approval_submit: {
        ...formMeta,
    },
    stage_gate_decision_panel: {
        ...formMeta,
    }

}

export type IPrefeasibilityFormValues =
    typeof prefeasibilityDefaultValues